import React from "react";
import moment from "moment";
import { Modal } from "reactstrap";
import { toExamDvsnCd } from "components/mypage/myExamInfo/examConstants";
import noticeRewardBg from "styles/common/img/examplan/bg_notice_popup_reward.webp";
import noticeDefaultBg from "styles/common/img/examplan/bg_notice_popup_default.webp";
import "./ExamPlanNoticePopup.scss";

/**
 * 별 10,000개 지급이 확정된 시험. (2회차 = 2026 2학기 기말고사)
 * 기획상 이번 기말까지만 10,000별 시안을 쓰고, 이후 시험은 중간/기말 구분 없이 일반 문구 시안을 쓴다.
 * EXAM_DVSN_CD_2 는 서버 DB용 값이라 쓰지 않고 SMST_CD + EXAM_DVSN_CD_1 로 판정한다.
 */
const REWARD_NOTICE_EXAMS = [{ YR: "2026", EXAM_DVSN_CD: "2F" }];

const isRewardNoticeExam = (missPlanInfo) =>
    REWARD_NOTICE_EXAMS.some(
        (exam) => exam.YR === String(missPlanInfo?.YR) && exam.EXAM_DVSN_CD === toExamDvsnCd(missPlanInfo),
    );

/**
 * 시험대비모드 시작 전 사전안내 팝업. (운영 시작 D-30 ~ D-1)
 * 시작일은 START_D_DAY(CMS 운영 시작일 기준 D-day)로 계산한다.
 * FIRST_ACTION_DT 는 학생의 최초 미션 수행일이라 시작 전에는 비어 있다.
 */
const ExamPlanNoticePopup = ({ isOpen, missPlanInfo, onClose, onCloseToday }) => {
    if (!missPlanInfo) return null;

    const startDDay = Number(missPlanInfo.START_D_DAY);
    // D-day 는 항상 두 자리로 보여준다. (5일 남았으면 05)
    const dDayDigits = String(startDDay).padStart(2, "0").split("");
    const startDate = moment().add(startDDay, "days").format("YYYY-MM-DD");
    const isReward = isRewardNoticeExam(missPlanInfo);

    return (
        <Modal
            isOpen={Boolean(isOpen)}
            backdrop="static"
            keyboard={false}
            modalClassName="expln-prenotice-modal"
            className="expln-prenotice"
        >
            <div className="expln-prenotice__body">
                {/* 제목/단계/하단 문구는 시안 이미지에 포함되어 있다. (D-day, 날짜, 버튼만 코드로 그린다) */}
                <img
                    className="expln-prenotice__bg"
                    src={isReward ? noticeRewardBg : noticeDefaultBg}
                    alt="시험대비모드 안내"
                />

                {/* X 는 그냥 닫기 : 홈에 다시 들어오면 또 노출된다. */}
                <button type="button" className="expln-prenotice__close" onClick={onClose} aria-label="닫기" />

                <div className="expln-prenotice__dday" aria-label={`D-${dDayDigits.join("")}`}>
                    <span className="expln-prenotice__dday-box" aria-hidden="true">
                        D
                    </span>
                    <span className="expln-prenotice__dday-dash" aria-hidden="true" />
                    {dDayDigits.map((digit, index) => (
                        <span key={index} className="expln-prenotice__dday-box" aria-hidden="true">
                            {digit}
                        </span>
                    ))}
                </div>

                <p className="expln-prenotice__date">
                    <span className="expln-prenotice__date-value">{startDate}</span> 부터 시험대비모드 ON!
                </p>

                <button type="button" className="expln-prenotice__today-close" onClick={onCloseToday || onClose}>
                    오늘은 그만 볼래요
                </button>
            </div>
        </Modal>
    );
};

export default ExamPlanNoticePopup;
